<template>
	<div class="payment-buyer" @click="setZipCodeAndAddress4IOS">
		<!-- 라이선스 전용 필드 -->
		<div class="license-info" v-if="isLicenseOrder">
			<h3>라이선스 설정</h3>
			<div class="buyer-info gui-form">
				<div class="row-box">
					<label class="label" for="crewId">팀 선택</label>
					<div class="inp-set">
						<select id="crewId" name="crewId" v-model="licenseInfo.crewId" @change="onCrewChange">
							<option value="0">+ 팀 생성</option>
							<option v-for="crew in crewList" :key="crew.id" :value="crew.id">{{ crew.crewName }}
							</option>
						</select>
					</div>
					<p class="information">해당 팀에 라이선스가 발급됩니다.</p>
					<div class="inp-set" v-if="licenseInfo.crewId === '0' || licenseInfo.crewId === 0">
						<input type="text" id="crewName" name="crewName" placeholder="팀 이름을 입력하세요"
							v-model="licenseInfo.crewName">
					</div>
				</div>
				<!-- 상품별 라이선스 시작/종료일 (옵션 만기에 따라 자동 계산) -->
				<div class="license-product-dates" v-for="item in licenseProductItems" :key="licenseItemKey(item)">
					<div class="row-box license-product-title">
						<span class="product-name">{{ getProductTitle(item.gid) }}</span>
						<span class="term-badge" v-if="item.licenseTermMonths">{{ formatTermLabel(item.licenseTermMonths) }}</span>
					</div>
					<div class="row-box license-product-options" v-if="item.optionSummary">
						<span class="option-label">선택 옵션:</span>
						<span class="option-summary">{{ item.optionSummary }}</span>
					</div>
					<div class="row-box">
						<label class="label">시작일</label>
						<div class="inp-set">
							<input type="date" :id="'startDate_' + licenseItemKey(item)" v-model="licenseInfoByProduct[licenseItemKey(item)].startDate"
								:min="minDate" @change="onLicenseStartDateChange(item)">
						</div>
					</div>
					<div class="row-box">
						<label class="label">만료일</label>
						<div class="inp-set">
							<input type="date" :id="'endDate_' + licenseItemKey(item)" :value="licenseInfoByProduct[licenseItemKey(item)].endDate" disabled>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 구매 유형 선택 (라이선스 정보 폼과 결제자 정보 폼 사이) -->
		<div class="company-checkbox">
			<input type="radio" id="isCompany" name="purchaseType" class="inp-radio" :value="true" v-model="licenseInfo.isCompany">
			<label for="isCompany" class="lab-radio company-label">기업 구매</label>
			<input type="radio" id="isPersonal" name="purchaseType" class="inp-radio" :value="false" v-model="licenseInfo.isCompany">
			<label for="isPersonal" class="lab-radio company-label">개인 구매</label>
		</div>

		<!-- 결제자 정보 폼 (항상 렌더링, 기업 구매일 때는 입력 필드만 숨김) -->
		<!-- mobile form -->
		<form id="mobileweb" name="mobileweb" method="POST" accept-charset="EUC-KR" style="display: none;">
			<input :type="isDev" name="P_NEXT_URL" :value="pg.siteDomain + pg.returnUrl + '?mode=MOBILE'">
			<input :type="isDev" name="P_INI_PAYMENT" :value="this.pg.payment">
			<input :type="isDev" name="P_MID" :value="pg.mid">
			<input :type="isDev" name="P_GOODS" :value="pg.oid">
			<input :type="isDev" name="P_AMT" :value="totalCost">
			<input :type="isDev" name="P_UNAME" :value="orderInfo.deliveryReceiverName">
			<input :type="isDev" name="P_OID" :value="pg.oid">
		</form>

		<!-- pc form -->
		<form id="SendPayForm_id" name="SendPayForm_id" method="POST" accept-charset="EUC-KR" style="display: none;">
			<input :type="isDev" name="gopaymethod" :value="this.pg.payment"> <!-- 결제 수단 선택 : Card,DirectBank,HPP,Vbank,kpay,Swallet,Paypin,EasyPay,PhoneBill,GiftCard,EWallet
																					onlypoint,onlyocb,onyocbplus,onlygspt,onlygsptplus,onlyupnt,onlyupntplus -->
			<input :type="isDev" name="version" value="1.0"> <!-- 전문버전 1.0 고정 -->
			<input :type="isDev" name="logo_url"
				:value="pg.siteDomain + '/ssflex/assets/img/temp/temp_logo_pg.png'">
			<!-- 메인로고 삽입 [size: 89*18] -->
			<input :type="isDev" name="logo_2nd"
				:value="pg.siteDomain + '/ssflex/assets/img/temp/temp_logo_pg.png'">
			<!-- 서브로고 삽입 [size: 64*13] -->
			<input :type="isDev" name="mid" :value="pg.mid"> <!-- 상점아이디 -->
			<input :type="isDev" name="goodname" :value="pg.oid"> <!-- oid? -->
			<input :type="isDev" name="price" :value="totalCost"> <!-- 결제금액 (숫자만, 1달러는 100으로 시작) -->
			<!--				<input :type="isDev" name="price" :value="100">                    &lt;!&ndash; 결제금액 (숫자만, 1달러는 100으로 시작) 테스트용&ndash;&gt;-->
			<input :type="isDev" name="timestamp" :value="pg.timestamp"> <!-- 타임스템프 [TimeInMillis(Long형)] -->
			<input :type="isDev" name="signature" :value="pg.signature">
			<!-- SHA256 Hash값 [대상: oid, price, timestamp] -->
			<input :type="isDev" name="mKey" :value="pg.mKey"> <!-- SHA256 Hash값 [대상: mid 와 매칭되는 signkey]   -->
			<input :type="isDev" name="currency" value="WON"> <!-- 통화구분 ["WON":한화,"USD":달러] -->
			<!-- <input :type="isDev" name="buyername" value="홍길동" >-->
			<!-- <input :type="isDev" name="buyertel" value="010-1234-5678" >--> <!-- 구매자 휴대폰번호 -->
			<input :type="isDev" name="buyeremail" :value="orderInfo.email">
			<!-- 구매자 이메일주소 "@", "." 외 특수문자 입력불가 -->
			<input :type="isDev" name="acceptmethod" value="below1000">
			<!--				<input :type="isDev"  name="acceptmethod" :value="'vbank('+ vBankDate +')'">-->
			<input :type="isDev" name="payViewType" value=""> <!-- popupUrl 사용시 popup으로 반드시 설정 -->
			<input :type="isDev" name="returnUrl" :value="pg.siteDomain + pg.returnUrl + '?mode=WEB'">
			<!-- 결과수신 URL -->
			<input :type="isDev" name="closeUrl" :value="pg.siteDomain + closeUrl"> <!-- 결제창 닫기 URL -->
			<!--				<input :type="isDev" name="popupUrl" :value="pg.siteDomain + popupUrl">       &lt;!&ndash; payViewType='popup'시 팝업을 띄울수 있도록 처리해주는 URL (선택) &ndash;&gt;-->
			<input :type="isDev" name="oid" :value="pg.oid">

			<!-- 결제자 정보 입력 필드 (항상 렌더링, 기업 구매일 때는 hidden) -->
			<div class="row-box" :style="{ display: licenseInfo.isCompany ? 'none' : 'block' }">
				<label class="label" for="buyername">이름</label>
				<div class="inp-set">
					<input id="buyername" name="buyername" type="text" placeholder="이름"
						v-model="orderInfo.deliveryReceiverName">
				</div>
			</div>
			<div class="row-box" :style="{ display: licenseInfo.isCompany ? 'none' : 'block' }">
				<label class="label" for="buyertel">전화번호</label>
				<div class="inp-set">
					<input id="buyertel" name="buyertel" type="tel" maxlength="12" placeholder="전화번호"
						v-model="orderInfo.deliveryReceiverPhone" @keyup="numberUtils.setOnlyNum('buyertel')"
						@change="checkPhone()">
				</div>
				<p v-html="infoMsg" v-if="!licenseInfo.isCompany"></p>
			</div>
			<div class="row-box" :style="{ display: licenseInfo.isCompany ? 'none' : 'block' }">
				<label class="label" for="email">이메일</label>
				<div class="inp-sel-set">
					<input id="email" class="inp-mail" name="email" type="email" placeholder="이메일 아이디"
						v-model="orderInfo.email" @change="checkEmail">
					<select id="email2" name="email2" v-model="email2">
						<option value="naver.com">naver.com</option>
						<option value="nate.com">nate.com</option>
						<option value="gmail.com">gmail.com</option>
						<option value="hanmail.net">hanmail.net</option>
						<option value="yahoo.com">yahoo.com</option>
						<option value="hotmail.com">hotmail.com</option>
						<option value="daum.net">daum.net</option>
						<option value="korea.kr">korea.kr</option>
						<option value="paran.com">paran.com</option>
						<option value="">직접입력</option>
					</select>
				</div>
			</div>
			<div class="row-box address" :style="{ display: licenseInfo.isCompany ? 'none' : 'block' }">
				<label class="label" for="zipcode">주소</label>
				<div class="inp-btn-set">
					<input id="zipcode" name="zipcode" type="text" disabled v-model="orderInfo.deliveryZipcode">
					<button type="button" @click="postCode()">주소검색</button>
				</div>
				<div class="inp-set">
					<input id="address1" name="address1" type="text" placeholder="동(읍/면) 까지의 주소" disabled
						v-model="orderInfo.deliveryAddress1">
				</div>
				<div class="inp-set">
					<input id="address2" name="address2" type="text" placeholder="상세주소"
						v-model="orderInfo.deliveryAddress2">
				</div>
			</div>
		</form>

		<!-- 결제자 정보 입력 필드 (기업 구매가 아닐 때만 표시) -->
		<template v-if="!licenseInfo.isCompany">
			<h3>결제자 정보</h3>
			<div class="buyer-info gui-form">
					<div class="row-box">
						<label class="label" for="buyername">이름</label>
						<div class="inp-set">
							<input id="buyername" name="buyername" type="text" placeholder="이름"
								v-model="orderInfo.deliveryReceiverName">
						</div>
					</div>
					<div class="row-box">
						<label class="label" for="buyertel">전화번호</label>
						<div class="inp-set">
							<input id="buyertel" name="buyertel" type="tel" maxlength="12" placeholder="전화번호"
								v-model="orderInfo.deliveryReceiverPhone" @keyup="numberUtils.setOnlyNum('buyertel')"
								@change="checkPhone()">
						</div>
						<p v-html="infoMsg"></p>
					</div>
					<div class="row-box">
						<label class="label" for="email">이메일</label>
						<div class="inp-sel-set">
							<input id="email" class="inp-mail" name="email" type="email" placeholder="이메일 아이디"
								v-model="orderInfo.email" @change="checkEmail">
							<select id="email2" name="email2" v-model="email2">
								<option value="naver.com">naver.com</option>
								<option value="nate.com">nate.com</option>
								<option value="gmail.com">gmail.com</option>
								<option value="hanmail.net">hanmail.net</option>
								<option value="yahoo.com">yahoo.com</option>
								<option value="hotmail.com">hotmail.com</option>
								<option value="daum.net">daum.net</option>
								<option value="korea.kr">korea.kr</option>
								<option value="paran.com">paran.com</option>
								<option value="">직접입력</option>
							</select>
						</div>
					</div>
					<div class="row-box address">
						<label class="label" for="zipcode">주소</label>
						<div class="inp-btn-set">
							<input id="zipcode" name="zipcode" type="text" disabled v-model="orderInfo.deliveryZipcode">
							<button type="button" @click="postCode()">주소검색</button>
						</div>
						<div class="inp-set">
							<input id="address1" name="address1" type="text" placeholder="동(읍/면) 까지의 주소" disabled
								v-model="orderInfo.deliveryAddress1">
						</div>
						<div class="inp-set">
							<input id="address2" name="address2" type="text" placeholder="상세주소"
								v-model="orderInfo.deliveryAddress2">
						</div>
					</div>
			</div>
			<p class="information">결제자의 정보로 결제와 관련된 정보가 제공됩니다. 정확하게 입력해 주세요.</p>
		</template>

		<!-- 기업 구매일 때 고객 정보 입력 폼 -->
		<template v-if="licenseInfo.isCompany">
			<h3>기업정보 입력</h3>
			<div class="buyer-info gui-form">
				<div class="row-box" v-if="clientList.length > 0">
					<label class="label" for="clientSelect">이전 기업정보 목록</label>
					<div class="inp-set">
						<select id="clientSelect" name="clientSelect" v-model="selectedClientId" @change="onClientSelect">
							<option value="0">기업정보 선택</option>
							<option v-for="client in clientList" :key="client.id" :value="client.id">
								{{ client.companyName }}(담당자:{{ client.clientManager }})
							</option>
						</select>
					</div>
				</div>
				<!-- 고객사 정보 수정하기 체크박스 (고객사 선택 시에만 표시) -->
				<div class="row-box" v-if="selectedClientId && selectedClientId !== '0'">
					<div class="client-edit-checkbox">
						<input type="checkbox" id="allowEditClient" class="inp-check" v-model="isClientInfoEditable" @change="onClientEditChange">
						<label for="allowEditClient" class="lab-check">기업 정보 수정하기</label>
					</div>
				</div>
				<div class="row-box">
					<label class="label" for="companyName">회사명</label>
					<div class="inp-set">
						<input type="text" id="companyName" name="companyName" placeholder="회사명"
							v-model="licenseInfo.companyName" :disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">
					</div>
				</div>
				<div class="row-box">
					<label class="label" for="bizNo">사업자번호</label>
					<div class="inp-set">
						<input type="text" id="bizNo" name="bizNo" placeholder="사업자번호 (예: 123-45-67890)"
							v-model="licenseInfo.bizNo" @keyup="numberUtils.setBizNo('bizNo')"
							:disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">
					</div>
				</div>
				<div class="row-box row-box-biz-file">
					<label class="label" for="bizFile">사업자등록증 사본</label>
					<div class="inp-set">
						<div class="biz-file-input-row">
							<input type="file" id="bizFile" ref="bizFileInput" accept=".jpg,.jpeg,.png,.gif,.pdf"
								:disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable"
								@change="onBizFileSelect">
							<button type="button" class="btn-remove-biz-file" @click="removeBizFile"
								:disabled="!(licenseInfo.bizFileFidx || selectedBizFileName)">삭제</button>
						</div>
						<p v-if="licenseInfo.bizFileFidx" class="biz-file-download">
							등록된 파일:
							<a :href="licenseInfo.bizFileDownloadUrl" target="_blank" download rel="noopener noreferrer">
								{{ licenseInfo.bizFileName || '다운로드' }}
							</a>
						</p>
						<p class="information">최대 {{ bizFileMaxSizeMB }}MB (jpg, jpeg, png, gif, pdf)</p>
					</div>
				</div>
				<div class="row-box">
					<label class="label" for="clientManager">담당자 이름</label>
					<div class="inp-set">
						<div class="client-account-checkbox" v-show="!(selectedClientId && selectedClientId !== '0' && !isClientInfoEditable)">
							<input type="checkbox" id="useCurrentAccount" class="inp-check" v-model="useCurrentAccount" @change="onUseCurrentAccountChange">
							<label for="useCurrentAccount" class="lab-check">현재 계정 정보와 동일</label>
						</div>
						<input type="text" id="clientManager" name="clientManager" placeholder="담당자 이름"
							v-model="licenseInfo.clientManager" :disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">
					</div>
				</div>
				<div class="row-box">
					<label class="label" for="managerEmail">담당자 이메일</label>
					<div class="inp-sel-set">
						<input id="managerEmail" class="inp-mail" name="managerEmail" type="email" placeholder="이메일 아이디"
							v-model="licenseInfo.managerEmail" @change="checkManagerEmail"
							:disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">
						<select id="managerEmail2" name="managerEmail2" v-model="managerEmail2"
							:disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">
							<option value="naver.com">naver.com</option>
							<option value="nate.com">nate.com</option>
							<option value="gmail.com">gmail.com</option>
							<option value="hanmail.net">hanmail.net</option>
							<option value="yahoo.com">yahoo.com</option>
							<option value="hotmail.com">hotmail.com</option>
							<option value="daum.net">daum.net</option>
							<option value="korea.kr">korea.kr</option>
							<option value="paran.com">paran.com</option>
							<option value="">직접입력</option>
						</select>
					</div>
					<p v-if="isLicenseOrder" class="information">Box Series 상품 구매시 현재 로그인하신 계정으로 라이선스가 발급됩니다.</p>
				</div>
				<div class="row-box address">
					<label class="label" for="clientZipcode">주소</label>
					<div class="inp-btn-set">
						<input id="clientZipcode" name="clientZipcode" type="text" disabled
							v-model="licenseInfo.clientZipcode">
						<button type="button" @click="postCodeForClient()"
							:disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">주소검색</button>
					</div>
					<div class="inp-set">
						<input id="clientAddress1" name="clientAddress1" type="text" placeholder="동(읍/면) 까지의 주소"
							disabled v-model="licenseInfo.clientAddress1">
					</div>
					<div class="inp-set">
						<input id="clientAddress2" name="clientAddress2" type="text" placeholder="상세주소"
							v-model="licenseInfo.clientAddress2" :disabled="selectedClientId && selectedClientId !== '0' && !isClientInfoEditable">
					</div>
				</div>
			</div>
			<p class="information">기업 정보를 정확하게 입력해 주세요.</p>
		</template>

		<!-- 개인정보·마케팅 동의 (개인/기업 구매 공통) -->
		<div class="consent-section">
			<div class="consent-row">
				<p class="inforAgree">개인정보 수집 및 이용 동의(필수)</p>
				<button type="button" class="inforAgreeBtn" @click="openStaticPage('/app/statics/privacyConcent')">내용보기</button>
				<span class="consent-choice">
					<input type="checkbox" id="privacyConsent" class="inp-check" v-model="privacyConsentAgreed">
					<label for="privacyConsent" class="lab-check">동의합니다</label>
				</span>
			</div>
			<div class="consent-row">
				<p class="inforAgree">마케팅 활용 및 정보 수신동의(선택)</p>
				<button type="button" class="inforAgreeBtn" @click="openStaticPage('/app/statics/marketingConcent')">내용보기</button>
				<span class="consent-choice">
					<input type="radio" id="marketingConsentY" name="marketingConsent" class="inp-radio" :value="true" v-model="marketingConsent">
					<label for="marketingConsentY" class="lab-radio">동의합니다</label>
					<input type="radio" id="marketingConsentN" name="marketingConsent" class="inp-radio" :value="false" v-model="marketingConsent">
					<label for="marketingConsentN" class="lab-radio">동의하지 않습니다</label>
				</span>
			</div>
		</div>

		<div class="payment-method">
			<h3>결제방법</h3>
			<ul class="method-list" @change="changePaymnt">
				<li>
					<input type="radio" name="paymentType" id="credit-card" class="inp-radio" value="C" checked
						v-model="orderInfo.paidType">
					<label for="credit-card" class="lab-radio">신용카드</label>
				</li>
				<!--				<li>-->
				<!--					<input type="radio" name="paymentType" id="bank-transfer" class="inp-radio" value="B" v-model="orderInfo.paidType">-->
				<!--					<label for="bank-transfer" class="lab-radio">계좌이체</label>-->
				<!--				</li>-->
				<!--				<li>-->
				<!--					<input type="radio" name="paymentType" id="bank-deposit" class="inp-radio" value="D" v-model="orderInfo.paidType">-->
				<!--					<label for="bank-deposit" class="lab-radio">무통장 입금</label>-->
				<!--				</li>-->
			</ul>
		</div>

		<div class="btn-area">
			<button type="button" class="btn-submit" name="pay" value="결제" @click="doPurchase()">결제 진행하기</button>
		</div>

		<!--		<script type="application/javascript" src="https://stgstdpay.inicis.com/stdjs/INIStdPay.js" charset="UTF-8"></script>-->
		<!--		<script type="application/javascript" src="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>-->
	</div>

</template>
<script>

import $ from 'jquery'
import moment from "moment";
import HWAPP from '@/commons/mixins/hwapp.mixin'

export default {
	name: "orderUser",
	mixins: [HWAPP],
	props: {
		orderInfo: Object,
		totalCost: Number,
		isLicenseOrder: Boolean,
		licenseProductList: {
			type: Array,
			default: () => []
		},
		orderProductList: {
			type: Array,
			default: () => []
		},
		selectedOptionDetails: {
			type: Array,
			default: () => []
		},
		producList: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			email1: "",
			email2: "",
			isDev: "hidden",
			pg: {},
			infoMsg: '<p class="information">예시) 01012345678</p>',
			closeUrl: "app/shop/closePg",
			// popupUrl: "shop/popupPg",
			vBankDate: new Date(),
			isIOS: false,
			crewList: [],
			clientList: [],
			selectedClientId: "0",
			licenseInfo: {
				crewId: "",
				crewName: "",
				isCompany: true,
				companyName: "",
				bizNo: "",
				bizFileFidx: "",
				bizFileName: "",
				bizFileDownloadUrl: "",
				clientManager: "",
				managerEmail: "",
				clientAddress1: "",
				clientAddress2: "",
				clientZipcode: "",
				clientId: "",
			},
			managerEmail2: "",
			isClientInfoEditable: false,
			useCurrentAccount: false,
			selectedBizFileName: "",
			bizFileMaxSizeMB: 1,
			inicisMobilePaymentUrl: "https://mobile.inicis.com/smart/payment/",
			privacyConsentAgreed: false,
			marketingConsent: null,
			/** 상품(gid)별 라이선스 시작/종료일 { [gid]: { startDate, endDate } } */
			licenseInfoByProduct: {},
		}
	},
	computed: {
		minDate() {
			return moment().format('YYYY-MM-DD');
		},
		/** 라이선스 상품만 필터 (orderProductList 중 licenseProductList에 있는 gid) */
		licenseProductItems() {
			if (!this.licenseProductList || this.licenseProductList.length === 0) return [];
			const gidSet = new Set(this.licenseProductList.map(l => l.gid));
			return (this.orderProductList || []).filter(item => gidSet.has(item.gid));
		},
	},
	watch: {
		isLicenseOrder(newVal) {
			if (newVal) {
				this.getCrewAdminList();
				this.initLicenseInfoByProduct();
			}
		},
		orderProductList: {
			handler() {
				if (this.isLicenseOrder) this.initLicenseInfoByProduct();
			},
			deep: true
		},
	},
	updated() {
	},
	created() {
		this.axiosCaller.get(this, this.APIs.SHOP_PG + "/config", {}, (res) => {
			const data = res.data || {};
			const scriptUrl = data.inicisTest
				? "https://stgstdpay.inicis.com/stdjs/INIStdPay.js"
				: "https://stdpay.inicis.com/stdjs/INIStdPay.js";
			if (data.inicisMobilePaymentUrl) this.inicisMobilePaymentUrl = data.inicisMobilePaymentUrl;
			this.$loadScript(scriptUrl).then(() => this.getPgInfo());
		}, () => {
			this.swalUtils.gritter("결제 설정을 불러올 수 없습니다.", "잠시 후 다시 시도해 주세요.", "error");
		});
		this.$loadScript("//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js")
		if (this.isLicenseOrder) {
			this.getCrewAdminList();
			this.licenseInfo.startDate = moment().format('YYYY-MM-DD');
			this.licenseInfo.endDate = moment().add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');
		}
		this.getClientList();
	},
	mounted() {
		this.vBankDate = moment(this.vBankDate).add(2, 'days').format("YYYYMMDD")
		console.log('vBankDate', this.vBankDate)
	},
	methods: {
		pay() {
			var myform = document.mobileweb;
			myform.action = this.inicisMobilePaymentUrl;
			myform.target = "_self";
			myform.submit();
		},
		async doPurchase() {
			const self = this;

			if (!this.isLogin()) {
				await this.requireLogin(this, false);
				return;
			}

			// getIniInfo 콜백 시점에 licenseInfo가 비어 있을 수 있으므로, 클릭 직후 스냅샷 저장
			self._pendingLicenseInfo = JSON.parse(JSON.stringify(self.licenseInfo));
			self._pendingLicenseInfoByProduct = JSON.parse(JSON.stringify(self.licenseInfoByProduct));

			this.axiosCaller.get(this, this.APIs.SHOP_PG + "/getIniInfo", {
				totalPrice: this.totalCost
				// totalPrice : '100'
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					this.pg = result.pg;
					self.orderInfo.oid = self.pg.oid
					console.log('pginfo self.orderInfo.oid', self.orderInfo.oid)

					console.log('===pg====', this.pg)
					self.checkInfo()
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
						.then(() => {
							location.href = document.referrer
						})
				}
			})


		},
		checkInfo() {
			const self = this;
			// getIniInfo 콜백 시점의 폼 상태 대신, 클릭 시 저장한 스냅샷으로 검증
			const licenseInfoToUse = self._pendingLicenseInfo || self.licenseInfo;
			const licenseInfoByProductToUse = self._pendingLicenseInfoByProduct || self.licenseInfoByProduct;

			// 주문 금액
			self.orderInfo.orderPrice = self.totalCost;
			console.log("doPurchase", self.orderInfo);

			// 1. 결제 수단 필수 (기업/개인 공통)
			if (self.orderInfo.paidType === "") {
				self.swalUtils.gritter('결제 수단을 선택해 주세요.', "", "info", 1000)
				return
			}

			// 1-1. 개인정보 수집 및 이용 동의 필수
			if (!self.privacyConsentAgreed) {
				self.swalUtils.gritter('개인정보 수집 및 이용에 동의해 주세요.', "", "info", 1000)
				return
			}

			// 1-2. 마케팅 활용 및 정보 수신동의 선택 필수
			if (self.marketingConsent === null || self.marketingConsent === undefined) {
				self.swalUtils.gritter('마케팅 활용 및 정보 수신동의에 동의 여부를 선택해 주세요.', "", "info", 1000)
				return
			}

			// 2. 기업구매 / 개인구매 둘 중 하나만 검증 (선택한 쪽만)
			if (licenseInfoToUse.isCompany) {
				// 기업구매: 기업 관련 정보만 검증
				if (!licenseInfoToUse.companyName || licenseInfoToUse.companyName.trim() === "") {
					self.swalUtils.gritter('회사명을 입력해 주세요.', "", "info", 1000)
					return
				}
				if (!licenseInfoToUse.bizNo || licenseInfoToUse.bizNo.trim() === "") {
					self.swalUtils.gritter('사업자번호를 입력해 주세요.', "", "info", 1000)
					return
				}
				if (!licenseInfoToUse.clientManager || licenseInfoToUse.clientManager.trim() === "") {
					self.swalUtils.gritter('담당자 이름을 입력해 주세요.', "", "info", 1000)
					return
				}
				if (!licenseInfoToUse.managerEmail || (licenseInfoToUse.managerEmail.indexOf("@") === -1 && self.managerEmail2 === "")) {
					self.swalUtils.gritter('담당자 이메일 형식이 맞지 않습니다.', "", "info", 1000)
					return
				}
				if (!licenseInfoToUse.clientAddress1 || licenseInfoToUse.clientAddress1.trim() === "") {
					self.swalUtils.gritter('주소를 입력해 주세요.', "", "info", 1000)
					return
				}
			} else {
				// 개인구매: 개인(결제자) 관련 정보만 검증
				if (!self.orderInfo.deliveryReceiverName || self.orderInfo.deliveryReceiverName.trim() === "") {
					self.swalUtils.gritter('결제자 정보를 입력해 주세요.', "", "info", 1000)
					return
				}
				if (!self.orderInfo.deliveryReceiverPhone || self.orderInfo.deliveryReceiverPhone.trim() === "") {
					self.swalUtils.gritter('결제자 정보를 입력해 주세요.', "", "info", 1000)
					return
				}
				if (self.orderInfo.email.indexOf("@") === -1 && self.email2 !== "") {
					self.orderInfo.email = self.orderInfo.email + '@' + self.email2
				}
				if (!self.orderInfo.email || self.orderInfo.email.trim() === "" || (self.orderInfo.email.indexOf("@") === -1 && self.email2 === "")) {
					self.swalUtils.gritter('이메일 정보를 올바르게 입력해 주세요.', "", "info", 1000)
					return
				}
				if (self.infoMsg === '<p class="information" style="color: #ea5555;">올바른 번호가 아닙니다.</p>') {
					self.swalUtils.gritter('올바른 정보를 입력해 주세요.', "", "info", 1000)
					return
				}
				if (!self.orderInfo.deliveryAddress1 || self.orderInfo.deliveryAddress1.trim() === "") {
					self.swalUtils.gritter('주소를 입력해 주세요.', "", "info", 1000)
					return
				}
			}

			// 3. 라이선스 주문일 때만: crewId, crewName, 상품별 startDate/endDate 검증
			if (self.isLicenseOrder) {
				if (!licenseInfoToUse.crewId && licenseInfoToUse.crewId !== 0) {
					self.swalUtils.gritter('팀을 선택해 주세요.', "", "info", 1000)
					return
				}
				if ((licenseInfoToUse.crewId === '0' || licenseInfoToUse.crewId === 0) && (!licenseInfoToUse.crewName || licenseInfoToUse.crewName.trim() === "")) {
					self.swalUtils.gritter('팀 이름을 입력해 주세요.', "", "info", 1000)
					return
				}
				for (const item of self.licenseProductItems) {
					const key = self.licenseItemKey(item);
					const byProduct = licenseInfoByProductToUse[key];
					if (!byProduct || !byProduct.startDate) {
						self.swalUtils.gritter('라이선스 시작일을 선택해 주세요.', "", "info", 1000)
						return
					}
					if (!byProduct.endDate) {
						self.swalUtils.gritter('만료일 정보가 없습니다.', "", "info", 1000)
						return
					}
				}
			}

			// 기업 구매이고 파일이 선택된 경우: 먼저 업로드 후 주문 전송
			const input = self.$refs.bizFileInput;
			const hasFile = input && input.files && input.files.length > 0;
			if (licenseInfoToUse.isCompany && hasFile) {
				const file = input.files[0];
				const maxBytes = self.bizFileMaxSizeMB * 1024 * 1024;
				if (file.size > maxBytes) {
					self.swalUtils.gritter(
						`파일 용량은 최대 ${self.bizFileMaxSizeMB}MB까지 가능합니다.`,
						"",
						"error",
						2000
					);
					return;
				}
				const formData = new FormData();
				formData.append('file', file);
				formData.append('duration', '0');
				self.axiosCaller.post(self, self.APIs.FILES + '/upload', formData, (res) => {
					if (res.data.status === 'ok' && res.data.files && res.data.files[0]) {
						const f = res.data.files[0];
						self.licenseInfo.bizFileFidx = f.fidx;
						self.licenseInfo.bizFileName = f.name || file.name;
						self.licenseInfo.bizFileDownloadUrl = self.APIs.FILES_DOWN + f.fidx;
						// payload용 스냅샷에도 업로드 결과 반영
						if (self._pendingLicenseInfo) {
							self._pendingLicenseInfo.bizFileFidx = f.fidx;
							self._pendingLicenseInfo.bizFileName = f.name || file.name;
							self._pendingLicenseInfo.bizFileDownloadUrl = self.APIs.FILES_DOWN + f.fidx;
						}
						self.submitOrderAndPay();
					} else {
						self.swalUtils.gritter(res.data.msg || '파일 업로드에 실패했습니다.', '', 'error', 2000);
					}
				});
				return;
			}

			self.submitOrderAndPay();
		},
		/** 주문 저장 후 결제창 호출 */
		submitOrderAndPay() {
			const self = this;
			// getIniInfo 콜백 시점의 폼 대신, 클릭 시 저장한 스냅샷 우선 사용
			const licenseInfoToUse = self._pendingLicenseInfo || self.licenseInfo;
			const licenseInfoByProductToUse = self._pendingLicenseInfoByProduct || self.licenseInfoByProduct;

			const orderData = {
				orderInfo: self.orderInfo,
				cidxs: self.$route.query.cidxs,
				gidx: self.$route.query.gidx,
				count: self.$route.query.count,
				privacyConsentAgreed: self.privacyConsentAgreed,
				marketingConsent: self.marketingConsent,
			};

			// 모든 구매에 대해 상품 리스트를 문자열화한 리스트로 전송 (상품별 gid, quantity, optionDetailIds + 라이선스 상품이면 라이선스 정보)
			const licenseGidSet = self.licenseProductList && self.licenseProductList.length > 0
				? new Set(self.licenseProductList.map(l => l.gid))
				: new Set();
			const licenseInfoList = (self.orderProductList || []).map(item => {
				const isLicense = licenseGidSet.has(item.gid);
				const itemKey = isLicense ? (item.gid + '_' + (item.optionIds || '')) : '';
				const byProduct = isLicense ? (licenseInfoByProductToUse[itemKey] || {}) : {};
				return {
					gid: item.gid,
					quantity: item.quantity,
					optionDetailIds: item.optionIds != null && item.optionIds !== '' ? String(item.optionIds) : "",
					isLicenseOrder: isLicense,
					isCompany: licenseInfoToUse.isCompany,
					crewId: isLicense ? licenseInfoToUse.crewId : "",
					crewName: isLicense ? licenseInfoToUse.crewName : "",
					startDate: isLicense ? (byProduct.startDate || "") : "",
					endDate: isLicense ? (byProduct.endDate || "") : "",
					clientManager: licenseInfoToUse.isCompany ? licenseInfoToUse.clientManager : self.orderInfo.deliveryReceiverName,
					managerEmail: licenseInfoToUse.isCompany ? licenseInfoToUse.managerEmail : self.orderInfo.email,
					companyName: licenseInfoToUse.isCompany ? licenseInfoToUse.companyName : "",
					bizNo: licenseInfoToUse.isCompany ? licenseInfoToUse.bizNo : "",
					clientAddress1: licenseInfoToUse.isCompany ? licenseInfoToUse.clientAddress1 : self.orderInfo.deliveryAddress1,
					clientAddress2: licenseInfoToUse.isCompany ? licenseInfoToUse.clientAddress2 : self.orderInfo.deliveryAddress2,
					clientId: licenseInfoToUse.clientId || "",
					bizFileFidx: licenseInfoToUse.isCompany ? (licenseInfoToUse.bizFileFidx || "") : "",
				};
			});
			orderData.licenseInfo = JSON.stringify(licenseInfoList);

			self._pendingLicenseInfo = null;
			self._pendingLicenseInfoByProduct = null;

			self.axiosCaller.post(self, self.APIs.SHOP_ORDER + "/setOrder", orderData, (res) => {
				var result = res.data;
				if (result.status === "ok") {
					if (self.isMobileYn()) {
						self.pay();
					} else {
						window.INIStdPay.pay('SendPayForm_id');
					}
				} else {
					self.swalUtils.gritter("Error", result.msg, "error")
						.then(() => {
							location.href = document.referrer;
						});
				}
			});
		},
		getPgInfo() {
			var self = this;

			this.axiosCaller.get(this, this.APIs.SHOP_PG + "/getIniInfo", {
				totalPrice: this.totalCost
				// totalPrice : '100'
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					this.pg = result.pg;
					self.orderInfo.oid = self.pg.oid
					//console.log('pginfo self.orderInfo.oid',self.orderInfo.oid)

					//console.log('===pg====', this.pg)
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
						.then(() => {
							location.href = document.referrer
						})
				}
			});
		},
		/* 주소 찾기 */
		postCode() {
			var orderInfo = this.orderInfo
			// eslint-disable-next-line no-undef
			new daum.Postcode({
				oncomplete: function (data) {

					var roadAddr = data.roadAddress; // 도로명 주소 변수
					var jibunAddr = data.jibunAddress; // 지번 주소 변수

					// 우편번호와 주소 정보를 해당 필드에 입력.
					console.log(data.zonecode)
					orderInfo.deliveryZipcode = data.zonecode;
					if (roadAddr !== '') {
						console.log(roadAddr)
						orderInfo.deliveryAddress1 = roadAddr;
					} else if (jibunAddr !== '') {
						console.log(jibunAddr)
						orderInfo.deliveryAddress1 = jibunAddr;
					}
				}
			}).open();

			const url = "/postCode"
			var param = {
				"isCloseBTN": "Y",
				"url": this.APIs.BASE_URL + url,
				noWEB: true,
				noANDROID: true,
			};
			this.appOpen(param)
		},
		changePaymnt() {
			switch (this.orderInfo.paidType) {
				case "B":
					this.pg.payment = "DirectBank";
					break;
				case "C":
					this.pg.payment = "Card";
					break;
				case "D":
					this.pg.payment = "VBank";
					break;
				default:
					this.pg.payment = "Card";
					break;
			}
		},
		/** 주문폼 전용: 동의 내용보기를 새 창(팝업)으로 열기 */
		openStaticPage(_url) {
			let url = _url.startsWith("http") ? _url : this.APIs.BASE_URL + _url;
			url += url.indexOf('?') >= 0 ? '&popup=1' : '?popup=1';
			this.appOpen({
				url,
				target: '_blank',
				options: 'width=800,height=600,scrollbars=yes,resizable=yes'
			});
		},
		// 이메일 input(email id 영역) 태그 내 "a @ b" 형식 입력 시 이메일 select(email domain) 태그 "직접입력"으로 자동 변경
		checkEmail() {
			if (this.email1.indexOf("@") !== -1) {
				$('#email2').val('');
				$('#email2').prop("disabled", true);
			} else {
				$('#email2').prop("disabled", false)
			}
		},
		checkPhone() {
			var r = /^0([0-9]{2,3})-?([0-9]{3,4})-?([0-9]{4,5})$/;
			if (!r.test(this.orderInfo.deliveryReceiverPhone))
				this.infoMsg = '<p class="information" style="color: #ea5555;">올바른 번호가 아닙니다.</p>'
			else
				this.infoMsg = '<p class="information">예시) 01012345678</p>'
		},
		setZipCodeAndAddress4IOS() {
			this.orderInfo.deliveryZipcode = document.querySelector('#zipcode').value
			this.orderInfo.deliveryAddress1 = document.querySelector('#address1').value
		},

		getCrewAdminList() {
			const self = this;
			this.axiosCaller.get(this, this.APIs.LICENSE + "/getCrewAdminList", {
				userId: this.getSessionProc().coEmailId
			}, (res) => {
				if (res.data.status === "ok") {
					self.crewList = res.data.list || [];
				} else {
					console.error("팀 목록 조회 실패:", res.data.msg);
				}
			});
		},
		getClientList() {
			const self = this;
			// 팀 ID 리스트 추출
			const crewIds = self.crewList.map(crew => crew.id).join(',');
			this.axiosCaller.get(this, this.APIs.LICENSE + "/getClientListForLicenseOrder", {
				userId: this.getSessionProc().coEmailId,
				crewIds: crewIds
			}, (res) => {
				if (res.data.status === "ok") {
					self.clientList = res.data.list || [];
				} else {
					console.error("고객사 목록 조회 실패:", res.data.msg);
				}
			});
		},
		onClientSelect() {
			if (!this.selectedClientId || this.selectedClientId === "0") {
				// 고객사 새로 생성 선택 시
				this.isClientInfoEditable = false;
				this.licenseInfo.clientId = "0";
				this.licenseInfo.bizFileFidx = "";
				this.licenseInfo.bizFileName = "";
				this.licenseInfo.bizFileDownloadUrl = "";
				this.selectedBizFileName = "";
				if (this.$refs.bizFileInput) {
					this.$refs.bizFileInput.value = "";
				}
				return;
			}
			const selectedClient = this.clientList.find(client => client.id === parseInt(this.selectedClientId));
			if (selectedClient) {
				// clientId 저장
				this.licenseInfo.clientId = selectedClient.id.toString();
				// 수정 가능 상태 초기화 (선택 시 기본적으로 수정 불가)
				this.isClientInfoEditable = false;
				
				this.licenseInfo.companyName = selectedClient.companyName || "";
				this.licenseInfo.bizNo = selectedClient.bizNo || "";
				this.licenseInfo.clientManager = selectedClient.clientManager || "";
				this.licenseInfo.managerEmail = selectedClient.managerEmail || "";
				this.licenseInfo.clientAddress1 = selectedClient.clientAddress1 || "";
				this.licenseInfo.clientAddress2 = selectedClient.clientAddress2 || "";
				this.licenseInfo.clientZipcode = selectedClient.clientZipcode || "";

				// 사업자등록증 파일 정보 (fidx, 파일명, 다운로드 URL)
				this.licenseInfo.bizFileFidx = selectedClient.bizFileFidx != null ? selectedClient.bizFileFidx : "";
				this.licenseInfo.bizFileName = selectedClient.bizFileName || "";
				this.licenseInfo.bizFileDownloadUrl = selectedClient.bizFileFidx
					? (this.APIs.FILES_DOWN + selectedClient.bizFileFidx)
					: "";
				this.selectedBizFileName = selectedClient.bizFileName || "";
				if (this.$refs.bizFileInput) {
					this.$refs.bizFileInput.value = "";
				}

				// 이메일 파싱
				if (this.licenseInfo.managerEmail && this.licenseInfo.managerEmail.indexOf("@") !== -1) {
					const emailParts = this.licenseInfo.managerEmail.split("@");
					this.managerEmail2 = emailParts[1] || "";
				}
			}
		},

		/** 상품별 라이선스 시작/종료일 초기화 (옵션 만기에 따라 endDate 자동 계산) */
		initLicenseInfoByProduct() {
			const today = moment().format('YYYY-MM-DD');
			const byProduct = {};
			for (const item of this.licenseProductItems) {
				const key = this.licenseItemKey(item);
				const termMonths = item.licenseTermMonths || 12;
				const startDate = this.licenseInfoByProduct[key]?.startDate || today;
				const endDate = moment(startDate).add(termMonths, 'months').subtract(1, 'day').format('YYYY-MM-DD');
				byProduct[key] = { startDate, endDate };
			}
			this.licenseInfoByProduct = byProduct;
		},
		/** 시작일 변경 시 만료일 자동 재계산 */
		onLicenseStartDateChange(item) {
			const key = this.licenseItemKey(item);
			if (!this.licenseInfoByProduct[key]?.startDate) return;
			const termMonths = item.licenseTermMonths || 12;
			this.licenseInfoByProduct[key].endDate = moment(this.licenseInfoByProduct[key].startDate).add(termMonths, 'months').subtract(1, 'day').format('YYYY-MM-DD');
		},
		getProductTitle(gid) {
			const p = (this.producList || []).find(item => item.gid === gid);
			if (p && p.goodsVO && p.goodsVO.title) return p.goodsVO.title;
			if (p && p.title) return p.title;
			return '상품 #' + gid;
		},
		formatTermLabel(months) {
			if (months >= 12 && months % 12 === 0) return (months / 12) + '년';
			return months + '개월';
		},
		/** 같은 gid에 옵션만 다른 경우 구분용 키 */
		licenseItemKey(item) {
			return item.gid + '_' + (item.optionIds || '');
		},
		onCrewChange() {
			if (this.licenseInfo.crewId === '0' || this.licenseInfo.crewId === 0) {
				// 팀 생성 모드 - 팀 이름 초기화
				this.licenseInfo.crewName = "";
			} else {
				// 기존 팀 선택 시 팀 이름 설정
				const selectedCrew = this.crewList.find(crew => crew.id === parseInt(this.licenseInfo.crewId));
				if (selectedCrew) {
					this.licenseInfo.crewName = selectedCrew.crewName || "";
				}
			}
		},
		onClientEditChange() {
			if (this.isClientInfoEditable) {
				// 체크박스 체크 시: clientId를 "0"으로 설정하여 새로운 ClientInfoVO 생성
				this.licenseInfo.clientId = "0";
			} else {
				// 체크박스 해제 시: 원래 선택된 clientId로 복원
				if (this.selectedClientId && this.selectedClientId !== "0") {
					this.licenseInfo.clientId = this.selectedClientId;
				}
			}
		},
		onBizFileSelect(e) {
			const file = e.target.files && e.target.files[0];
			if (!file) {
				this.selectedBizFileName = "";
				return;
			}
			const maxBytes = this.bizFileMaxSizeMB * 1024 * 1024;
			if (file.size > maxBytes) {
				this.swalUtils.gritter(
					`파일 용량은 최대 ${this.bizFileMaxSizeMB}MB까지 가능합니다. (선택한 파일: ${(file.size / 1024 / 1024).toFixed(1)}MB)`,
					"",
					"error",
					3000
				);
				this.selectedBizFileName = "";
				if (this.$refs.bizFileInput) {
					this.$refs.bizFileInput.value = "";
				}
				return;
			}
			this.selectedBizFileName = file.name;
		},
		removeBizFile() {
			this.licenseInfo.bizFileFidx = "";
			this.licenseInfo.bizFileName = "";
			this.licenseInfo.bizFileDownloadUrl = "";
			this.selectedBizFileName = "";
			if (this.$refs.bizFileInput) {
				this.$refs.bizFileInput.value = "";
			}
		},
		onUseCurrentAccountChange() {
			if (this.useCurrentAccount) {
				// 체크박스 체크 시: 현재 계정 정보로 채우기
				if (this.orderInfo.deliveryReceiverName) {
					this.licenseInfo.clientManager = this.orderInfo.deliveryReceiverName;
				}
				if (this.orderInfo.email) {
					this.licenseInfo.managerEmail = this.orderInfo.email;
					// 이메일 파싱
					// if (this.licenseInfo.managerEmail && this.licenseInfo.managerEmail.indexOf("@") !== -1) {
					// 	const emailParts = this.licenseInfo.managerEmail.split("@");
					// 	this.managerEmail2 = emailParts[1] || "";
					// }
				}
			}
		},
		checkManagerEmail() {
			if (this.licenseInfo.managerEmail.indexOf("@") !== -1) {
				$('#managerEmail2').val('');
				$('#managerEmail2').prop("disabled", true);
			} else {
				$('#managerEmail2').prop("disabled", false)
			}
		},
		postCodeForClient() {
			var licenseInfo = this.licenseInfo
			// eslint-disable-next-line no-undef
			new daum.Postcode({
				oncomplete: function (data) {
					var roadAddr = data.roadAddress; // 도로명 주소 변수
					var jibunAddr = data.jibunAddress; // 지번 주소 변수

					// 우편번호와 주소 정보를 해당 필드에 입력.
					licenseInfo.clientZipcode = data.zonecode;
					if (roadAddr !== '') {
						licenseInfo.clientAddress1 = roadAddr;
					} else if (jibunAddr !== '') {
						licenseInfo.clientAddress1 = jibunAddr;
					}
				}
			}).open();

			const url = "/postCode"
			var param = {
				"isCloseBTN": "Y",
				"url": this.APIs.BASE_URL + url,
				noWEB: true,
				noANDROID: true,
			};
			this.appOpen(param)
		},





	}
}
</script>
<style scoped>
.consent-section {
	margin: 24px 0;
}

.consent-row {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px 16px;
	margin-bottom: 12px;
}

.consent-row .inforAgree {
	margin: 0;
	padding: 0;
	background: none;
}

.consent-choice {
	display: inline-flex;
	align-items: center;
	gap: 12px;
}

.inforAgree {
	padding-left: 24px;
	margin-top: 8px;
	background-size: 16px;
	background-position: left 2px;
	font-size: 14px;
	line-height: 1.5;
	color: var(--gray-dark);
}

.inforAgreeBtn {
	padding-left: 10px;
	background-size: 16px;
	background-position: left 2px;
	font-size: 14px;
	line-height: 1.5;
	color: var(--gray);
	text-decoration: underline;
}

/* 구매 유형 선택 라디오 버튼 스타일 (라이선스 정보 폼과 결제자 정보 폼 사이) */
.company-checkbox {
	margin: 24px 0;
	padding: 16px 0;
	display: flex;
	gap: 24px;
}

.company-checkbox .lab-radio {
	line-height: 24px;
	font-size: 15px;
	color: var(--gray600);
}

.company-checkbox .company-label {
	font-size: 18px;
	font-weight: 500;
}

/* 고객사 정보 수정하기 체크박스 스타일 */
.client-edit-checkbox {
	margin: 12px 0;
}

.client-edit-checkbox .lab-check {
	line-height: 24px;
	font-size: 15px;
	color: var(--gray600);
}

/* 현재 계정 정보와 동일 체크박스 스타일 */
.client-account-checkbox {
	margin-bottom: 8px;
}

.client-account-checkbox .lab-check {
	line-height: 24px;
	font-size: 14px;
	color: var(--gray600);
}

/* 현재 계정 정보와 동일 체크박스 스타일 */
.client-account-checkbox {
	margin-bottom: 8px;
}

.client-account-checkbox .lab-check {
	line-height: 24px;
	font-size: 14px;
	color: var(--gray600);
}

/* 사업자등록증 행: label과 입력 영역 높이 맞춤 */
.payment-buyer .buyer-info .row-box-biz-file {
	display: flex;
	align-items: flex-start;
	padding-left: 0;
}
.payment-buyer .buyer-info .row-box-biz-file .label {
	position: relative;
	top: auto;
	left: auto;
	width: 15%;
	flex-shrink: 0;
	min-height: 48px;
	display: flex;
	align-items: center;
	margin-bottom: 0;
}
.payment-buyer .buyer-info .row-box-biz-file .inp-set {
	flex: 1;
	min-width: 0;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-input-row {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: nowrap;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-input-row input[type="file"] {
	flex: 0 0 auto;
	width: auto;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-input-row .biz-file-name {
	flex: 0 1 auto;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-input-row .btn-remove-biz-file {
	flex: 0 0 auto;
	height: 36px;
	padding: 0 14px;
	color: black;
	font-size: 14px;
	font-weight: 500;
	border: 1px solid var(--gray200, #e0e0e0);
	background: var(--gray50, #f5f5f5);
	border-radius: 4px;
	cursor: pointer;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-input-row .btn-remove-biz-file:hover:not(:disabled) {
	background: var(--gray100, #eee);
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-input-row .btn-remove-biz-file:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-download {
	margin-top: 6px;
	font-size: 14px;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-download a {
	color: var(--primary, #2563eb);
	text-decoration: underline;
}
.payment-buyer .buyer-info .row-box-biz-file .biz-file-download a:hover {
	text-decoration: none;
}
/* 상품별 라이선스 기간 블록 */
.license-product-dates {
	border: 1px solid var(--gray200, #e0e0e0);
	border-radius: 8px;
	padding: 12px 16px;
	margin-bottom: 16px;
}
.license-product-dates .license-product-title {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 8px;
}
.license-product-dates .product-name {
	font-weight: 500;
	color: var(--gray-dark);
}
.license-product-dates .term-badge {
	font-size: 12px;
	padding: 2px 8px;
	background: var(--primary-light, #e3f2fd);
	color: var(--primary, #2563eb);
	border-radius: 4px;
}
.license-product-dates .license-product-options {
	margin-bottom: 8px;
	font-size: 13px;
	color: var(--gray600, #666);
}
.license-product-dates .option-label {
	font-weight: 500;
	margin-right: 4px;
}
@media (max-width: 767px) {
	.payment-buyer .buyer-info .row-box-biz-file {
		flex-direction: column;
	}
	.payment-buyer .buyer-info .row-box-biz-file .label {
		width: 100%;
		min-height: 0;
		margin-bottom: 8px;
	}
}
</style>
